module.exports = __webpack_public_path__ + "img/matr1x_fire_banner_novice_gift.d68e4457.png";